/**
 * Pure wording for step 6 (f10.9). Every count, the missing list and
 * `can_release` are the server's; nothing here decides readiness.
 */

import { ApiError, type ReleaseReadiness } from '@/api/client';

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** `17 Sep 2026`, in UTC so the day never shifts with the viewer's zone. */
export function releaseDate(iso: string): string {
  const date = new Date(iso);
  return `${date.getUTCDate()} ${SHORT_MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
}

export function committedLabel(committed: number | null | undefined, expected: number): string {
  return committed === null || committed === undefined
    ? `? of ${expected} committed`
    : `${committed} of ${expected} committed`;
}

export function releasedLine(readiness: ReleaseReadiness): string | null {
  const { released } = readiness;
  return released ? `Released ${releaseDate(released.at)} by ${released.by.display_name}` : null;
}

export function partialNotice(count: number): string {
  return `Released with ${count} missing item${count === 1 ? '' : 's'}`;
}

/** The dialog's refusal line; a stale readiness list re-renders instead. */
export function releaseFailure(error: unknown): string | null {
  if (!error) return null;
  if (error instanceof ApiError) {
    if (error.reason === 'CYCLE_VERSION_CONFLICT') {
      return 'This cycle changed — the latest state is shown.';
    }
    if (error.reason === 'CYCLE_RELEASE_INCOMPLETE') {
      return 'The data changed since you opened this dialog. Review the missing items again.';
    }
  }
  return error instanceof Error ? error.message : 'The cycle could not be released.';
}
